import isServer from '@framework/router/Next/isServer';
import globalKey from './globalKey';

export default (key: string): string => (
// @ts-ignore TODO: FIN-32798 strictNullChecks
  isServer() ? process.env[key] : window[globalKey]?.[key]
);
